/* eslint-disable no-unused-vars */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

export const GET_PLAN_TYPE_DATA = 'GET_PLAN_TYPE_DATA';
export const GET_CHECKED_VALUE = 'GET_CHECKED_VALUE';
export const GET_ERROR_MSG_CMS_MISMATCH = 'GET_ERROR_MSG_CMS_MISMATCH';
export const GET_REBATE_PROGRAM = 'GET_REBATE_PROGRAM';
export const SEARCH_SCREEN_TAB_CMS_MISMATCH = 'SEARCH_SCREEN_TAB_CMS_MISMATCH';
export const GET_QUARTER_VALUE = 'GET_QUARTER_VALUE';
export const GET_CMS_MISMATCH_DETAIL = 'GET_CMS_MISMATCH_DETAIL';
export const GET_CMS_MISMATCH_DETAIL_TAB_DATA =
  'GET_CMS_MISMATCH_DETAIL_TAB_DATA';
